import React, { Component } from "react";
import { connect } from "react-redux";
import { getSpk } from "../../../../Redux/reducer/env";
import { setPage } from '../../../../Redux/actions/sessionActions';
import { withRouter } from "react-router-dom";
import LoginTemplate from "../templates/landing";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Step3 from "./steps/step3";
import Step4 from "./steps/step4";
import EnrolmentProgressBar from "./enrolmentProgressBar";
import ResetPassProgressBar from "../password/resetPassProgressBar";
import ResetStep1 from "../password/steps/resetStep1";
import ResetStep2 from "../password/steps/resetStep2";
import ResetStep3 from "../password/steps/resetStep3";
import ResetStep4 from "../password/steps/resetStep4";
import ResetStep5 from "../password/steps/resetStep5";

export class AutoEnrolment extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      step: 1,
      user: {
        username: "",
        key: "",
        confirm_key: "",
        secretWord: "",
        questions: {},
        token: "",
        confirmSecretWord: "",
        codUser:""
      },
    };
  }

  componentDidMount() {
    this.props.setPage('register');
  }

  submitStep = (forward = true, state = undefined) => {
    var { step, user } = this.state;

    if (state !== undefined) {
      switch (step) {
        case 1:
          user.username = state.username;
          user.key = state.password;
          user.confirm_key = state.password;
          user.codUser = state.codUser;
          break;
        case 2:
          user.secretWord = state.secretWord;
          user.confirmSecretWord = state.confirmSecretWord;
          break;
        case 3:
          user.questions = state;
          break;
        case 4:
          user.token = state;
          break;
        default:
          break;
      }
    }

    if (forward) {
      step = step + 1;
    } else {
      step = step - 1;
    }

    this.setState({ step, user });
  };

  render() {
    const { step } = this.state;
    return (
      <LoginTemplate>
        {this.props.spk !== undefined &&
          this.props.spk !== "" &&
          (window.location.pathname !== "/user/reset-password" ? (
            <div className="enrolment">
              <div className="content">
                <EnrolmentProgressBar
                  stepNumber={this.state.step}
                  stepName={`Registro de usuario`}
                />
                <div className="step-content">
                  {step == 1 && (
                    <Step1
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                  {step == 2 && (
                    <Step2
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                  {step == 3 && (
                    <Step3
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                  {step == 4 && (
                    <Step4
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="enrolment">
              <div className="content">
                <ResetPassProgressBar
                  stepNumber={this.state.step}
                  stepName={`Recuperación de contraseña`}
                />
                <div className="step-content">
                  {step == 1 && (
                    <ResetStep1
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                  {step == 2 && (
                    <ResetStep2
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                  {step == 3 && (
                    <ResetStep3
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                  {step == 4 && (
                    <ResetStep4
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                  {step == 5 && (
                    <ResetStep5
                      submitStep={this.submitStep}
                      user={this.state.user}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
      </LoginTemplate>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
  };
};

export const mapDispatch = dispatch => ({
  setPage: (payload) => dispatch(setPage(payload))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatch
  )(AutoEnrolment)
);
